import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

export default function NotFound() {
  return (
    <Grid id="role-selection-grid" fluid>
      <Row id="role-selection-row">
        <Col xs={12} md={6} mdOffset={3} className="role-selection-col">
          <h4>Page not found. Please click the header to go home.</h4>
        </Col>
      </Row>
    </Grid>
  );
}
